(function () {
    //component definition for the find order form
    //form is used to lookup a customer's order to initiate a return
    angular.module('evo.returns.initiate.components').component('findOrderForm', {
        templateUrl: ['TEMPLATES_BASE', function (TEMPLATES_BASE) {
            return TEMPLATES_BASE + 'returns/initiate/components/findOrderForm'
        }],
        controller: function () {
            var ctrl = this;

            ctrl.findOrder = function (form) {
                //only update the parent component if the form is valid
                //and our values have changed since the last submit
                if (!form || !form.$valid || !form.$dirty) {
                    return;
                }

                form.$setPristine();
                ctrl.onFindOrder();
            };
        },
        bindings: {
            findOrderModel: '<',
            onFindOrder: '&'
        }
    });
})();